/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-15 14:11:27
 * @LastEditors: K
 * @LastEditTime: 2022-08-08 11:26:17
 */
/* eslint-disable react/display-name */
import { TableColumnType, Tooltip } from 'antd'
import React from 'react'
import { infoTypeName } from "../../../../models/sendMessage";





export const Columns = (
  startIndex: number,
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '5rem',
      render: (_1, _2, i) => `${startIndex + i + 1}`,
    },
    {
      title: '短信模板名称',
      dataIndex: 'templateName',
      key: 'templateName',
      align: 'center',
    },
    {
      title: '消息类型',
      dataIndex: 'smsType',
      key: 'smsType',
      align: 'center',
      render: (_, t) => {
        return infoTypeName(t.smsType)
      },
    },
    {
      title: '接收人/接收机构',
      dataIndex: 'reviceName',
      key: 'reviceName',
      align: 'center',
    },
    {
      title: '接收号码',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
    },
    {
      title: '短信内容',
      dataIndex: 'content',
      key: 'content',
      width: '200px',
      align: 'center',
      render: function content(_, t) {
        return t?.content
          ?
          <Tooltip
            title={t.content}
          >
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '200px', textAlign: 'center', }}>{t.content}</div>
          </Tooltip>

          : '-'
      },
    },
    {
      title: '创建人',
      dataIndex: 'createName',
      key: 'createName',
      align: 'center',
    },
    {
      title: '通知发送时间',
      dataIndex: 'sendTime',
      key: 'sendTime',
      align: 'center',
    },
  ]
}